import { render, staticRenderFns } from "./pile-echart.vue?vue&type=template&id=1a0d07b4&"
import script from "./pile-echart.vue?vue&type=script&lang=ts&"
export * from "./pile-echart.vue?vue&type=script&lang=ts&"
import style0 from "./pile-echart.vue?vue&type=style&index=0&id=1a0d07b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports